import { memo } from 'react'

type LockIconProps = {
  size?: number
  className?: string
}

export const LockIcon = memo(({ size = 12, className }: LockIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.768 4.518V3.768C9.768 2.148 9.378 0 6 0C2.622 0 2.232 2.148 2.232 3.768V4.518C0.552 4.728 0 5.58 0 7.674V8.79C0 11.25 0.75 12 3.21 12H8.79C11.25 12 12 11.25 12 8.79V7.674C12 5.58 11.448 4.728 9.768 4.518ZM6 10.044C4.998 10.044 4.188 9.228 4.188 8.232C4.188 7.23 5.004 6.42 6 6.42C6.996 6.42 7.812 7.236 7.812 8.232C7.812 9.234 7.002 10.044 6 10.044ZM3.21 4.464C3.162 4.464 3.12 4.464 3.072 4.464V3.768C3.072 2.01 3.57 0.84 6 0.84C8.43 0.84 8.928 2.01 8.928 3.768V4.47C8.88 4.47 8.838 4.47 8.79 4.47H3.21V4.464Z"
      fill="currentColor"
    />
  </svg>
))
LockIcon.displayName = 'LockIcon'
